export default "da2709a5cd7273c1.svg"